import {
  quiz
} from '../constants';
import { rfQuizReducer, mumQuizReducer, lmQuizReducer } from '../../helpers/quizReducer';
import { recyclingFundamentalsReducer, misundestoodMaterialsReducer, learningModulesReducer } from '../../helpers/discoveryReducer';

/**
 * Import constants
 */
const {
  SET_QUIZ,
  SET_QUIZ_STATE,
  UPDATE_QUIZ_DATA,
  SET_WHOLE_QUIZ_DATA
} = quiz;

/**
 * Action creators
 */

const actions = {
  setQuizData: ({
    rfQuiz,
    lmQuiz,
    mumQuiz,
    reducedFundamentals,
    reducedMisunderstood,
    reducedLearningModules
  }) => ({
    type: SET_QUIZ,
    data: {
      rfQuiz: rfQuizReducer(
        rfQuiz,
        recyclingFundamentalsReducer(reducedFundamentals)
      ),
      lmQuiz: lmQuizReducer(
        lmQuiz,
        learningModulesReducer(reducedLearningModules)
      ),
      mumQuiz: mumQuizReducer(
        mumQuiz,
        misundestoodMaterialsReducer(reducedMisunderstood)
      )
    }
  }),
  setQuizState: (data) => ({ type: SET_QUIZ_STATE, data }),
  updateQuizData: (data) => ({ type: UPDATE_QUIZ_DATA, data }),
  setWhole: (data) => ({ type: SET_WHOLE_QUIZ_DATA, data })
};

/**
 * Set whole quiz data coming from mobile
 */
export const setWhole = (data) => (dispatch) => dispatch(actions.setWhole(data));

/**
 * Set quiz data
 */
export const setQuizData = (data) => (dispatch) => dispatch(actions.setQuizData(data));

/**
 * Set quiz data
 */
export const setQuizState = (data) => (dispatch) => dispatch(actions.setQuizState(data));

/**
 * Set quiz data
 */
export const updateQuizData = (data) => (dispatch) => dispatch(actions.updateQuizData(data));
